import { transformListToMap, transformListToConst } from "../transform.js";
//访谈项目类型
export const INTERVIEW_PROJECT_TYPE_LIST = [
  {
    label: "通用访谈",
    key: "GENERAL_INTERVIEW",
    value: "通用访谈",
  },
  {
    label: "新闻访谈",
    key: "NEWS_INTERVIEW",
    value: "新闻访谈",
  },
  {
    label: "口述史",
    key: "ORAL_HISTORY",
    value: "口述史",
  },
  {
    label: "民族志",
    key: "ETHNOGRAPHY",
    value: "民族志",
  },
];
export const INTERVIEW_PROJECT_TYPE_MAP = transformListToMap(
  INTERVIEW_PROJECT_TYPE_LIST
);

export const INTERVIEW_PROJECT_TYPE = transformListToConst(
  INTERVIEW_PROJECT_TYPE_LIST
);

export const INTERVIEW_MODULE_LIST = [
  {
    label: "详情",
    key: "DETAIL",
    value: "DETAIL",
    icon: "iconfangtanxiangmu-xiangqing",
    to: {
      name: "InterviewProjectDetail",
    },
  },
  {
    label: "访谈",
    key: "INTERVIEW",
    value: "INTERVIEW",
    icon: "iconfangtanxiangmu-fangtan",
    to: {
      name: "InterviewList",
    },
  },

  {
    label: "团队",
    key: "TEAM",
    value: "TEAM",
    icon: "iconfangtanxiangmu-tuandui",
    to: {
      name: "InterviewTeam",
    },
  },
  {
    label: "案主",
    key: "SAMPLE",
    value: "SAMPLE",
    icon: "iconfangtanxiangmu-anzhu",
    to: {
      name: "InterviewSample",
    },
  },
  {
    label: "大纲",
    key: "OUTLINE",
    value: "OUTLINE",
    icon: "iconfangtanxiangmu-dagang",
    to: {
      name: "InterviewOutline",
    },
  },
  {
    label: "报表",
    key: "REPORT",
    value: "REPORT",
    icon: "icona-baobiaocipintongji",
    to: {
      name: "InterviewReport",
    },
  },
  {
    label: "附件",
    key: "ATTACHMENT",
    value: "ATTACHMENT",
    icon: "iconwenjian1",
    to: {
      name: "InterviewAttachment",
    },
  },
];
export const INTERVIEW_MODULE_MAP = transformListToMap(INTERVIEW_MODULE_LIST);
export const INTERVIEW_MODULE = transformListToConst(INTERVIEW_MODULE_LIST);

// 项目状态
export const INTERVIEW_PROJECT_STATUS_LIST = [
  {
    value: 1,
    label: "准备中",
    key: "PREPARING",
    type: "primary",
  },
  {
    value: 2,
    label: "已启动",
    key: "STARTED",
    type: "success",
  },
  {
    value: 3,
    label: "已暂停",
    key: "PAUSED",
    type: "primary",
  },
  {
    value: 4,
    label: "已结束",
    key: "FINISHED",
    type: "danger",
  },
];
export const INTERVIEW_PROJECT_STATUS_MAP = transformListToMap(
  INTERVIEW_PROJECT_STATUS_LIST
);
export const INTERVIEW_PROJECT_STATUS = transformListToConst(
  INTERVIEW_PROJECT_STATUS_LIST
);
